<template>
  <div v-if="showItem"
       class="item-standart">
    <div class="avatar">
      <child-avatar :child="child"
                    size="small"
                    icon="IconSmileSad"
                    icon-color="#fff"
                    icon-background-color="#7c65b5"
                    :show-status="false" />
    </div>
    <div class="content">
      <div class="description">
        {{ $t("feed.items.screentimeOverItem") }}
      </div>

      <div class="details">
        <feed-item-details :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'

  export default {
    extends: ItemBase,

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.item.user_id)
      },

      showItem() {
        return this.child
      }
    }
  }
</script>
